<template>
  <div class="top-page-base">
    <Notifications
      v-if="!!newsDataList && newsDataList.length > 0 && !!newsDataList[0].title"
      :message="!!newsDataList && newsDataList.length > 0 && !!newsDataList[0].title ? newsDataList[0].title : ''"
      :is-new="!!newsDataList && newsDataList.length > 0 ? +newsDataList[0].readed === 0 : false"
      :news-list="newsDataList"
      :enable-flg="hasNotification"
      :open-mess="true"
      @set-notification="()=>{}"
    />
    <!--
    <member-top-contents
      v-if="isSubscrEnable"
      :hot-taglist="hotTaglist"
      :receive-sections-data="pageData"
      :linkbtn-data="linkbtnData"
      :user-profile="userProfile"
      :slider-banner-list="sliderBannerList"
      :info-banner-list="infoBannerList"
      :is-subscr-enable="isSubscrEnable"
      :has-notification="hasNotification"
    />
    -->
    <member-top2023-contents
      v-if="isSubscrEnable"
      :hot-taglist="hotTaglist"
      :receive-sections-data="pageData"
      :linkbtn-data="linkbtnData"
      :user-profile="userProfile"
      :slider-banner-list="sliderBannerList"
      :info-banner-list="infoBannerList"
      :is-subscr-enable="isSubscrEnable"
      :has-notification="hasNotification"
      :received-features-list="featuresList"
    />
    <landing-page-contents
      v-else
      :user-profile="userProfile"
      :receive-sections-data="pageData"
      :is-subscr-enable="isSubscrEnable"
      :subsc-url="subscUrl"
      :has-notification="hasNotification"
    />
  </div>
</template>

<script>
import MemberTopContents from "./MemberTopContents";
import MemberTop2023Contents from "./MemberTop2023Contents";
import LandingPageContents from "./LandingPageContents";
import * as type from '@/utvStore/store/mutation-types'
import Notifications from '@/utvStore/components/partials/Notifications'

export default {
  name: "TopPage",
  components: {
    LandingPageContents,
    MemberTopContents,
    MemberTop2023Contents,
    Notifications,
  },
  data() {
    return {
      subsrcMovies: {},
      notificationEnable: false,
    }
  },
  props: {
    hotTaglist: {
      type: Array,
      default() {
        return []
      }
    },
    linkbtnData: {
      type: Array,
      default() {
        return []
      }
    },
    pageData: {
      type: Object,
      default() {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    sliderBannerList: {
      type: Array,
      default() {
        return []
      }
    },
    infoBannerList: {
      type: Array,
      default() {
        return []
      }
    },
    featuresList: {
      type: Array,
      default() {
        return []
      }
    },
    subscUrl: {
      type: String,
      require: true,
    },
    newsData: {
      type: [Array, Object],
      default() {
        return null
      }
    },
  },
  computed: {
    isSubscrEnable() {
      /**
       * ユーザーステータス
       * active:  0: 契約なし  1: 契約あり
       * status:  0: 初回  1: ケイゾク  2: 停止中  3: 解約申込  4: 解約済
       * current_peirod_from: 契約開始日時
       * current_peirod_to: 契約終了日時
       * free_buy: 特典デジコン無料チケット  0: 持ってない  1:あり
       * join_at: 契約起算日 <date>
       * unsubscription_at: 解約申込日 <date>
       * last_payment_at: 最終決済日時 <timestamp>
       * next_payment_due: 次回請求日 <date>
       */
      // LP出し分け: true -> 会員TOP  false -> 非会員LP
      const hasSubscription = !!this.userProfile && this.userProfile.subscription
      const active = parseInt(hasSubscription  ? this.userProfile.subscription.active : 0)
      const status = parseInt(hasSubscription ? this.userProfile.subscription.status : 0)

      if(!!this.userProfile) {
        return (active === 1
          && ( status === 0
            || status === 1
            || status === 2
            || status === 3 ))
        || (active === 0 && status === 2)
      } else {
        return status === 2
      }
    },
    newsDataList(){
      if(!Array.isArray(this.newsData)){
        return [{...this.newsData}]
      }
      return []
    },
    hasNotification(){
      return this.newsDataList.length > 0
    }
  },
  created() {
    this.$store.dispatch(type.SET_CATPAGE_REFERRER, '')
  },
  mounted(){
    dbg.info('PageData from Blade: %O', this.pageData)
    dbg.info('FeaturesList from Blade: %O', this.featuresList)
    dbg.info('UserProfile from Blade: %O', this.userProfile)
    dbg.info('InfoBannerList from Blade: %O', this.infoBannerList)
    dbg.info('sliderBannerList from Blade: %O', this.sliderBannerList)
    dbg.info('NewsData from Blade: %O', this.newsData)
  },
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/TopPage.vue